import detector from '@/utils/mobileDetector';

/* ============
 * State of the exteriors module
 * ============
 *
 * The initial state of the exteriors module.
 */
export default {
  exteriors: [],
  // for mobile platform (phones & tablets) the switcher must be turned on
  globalShowOverlayStatus: !!detector.mobile(),
  pois: [],
  isShowTogglePOI: true,
  isPoiMaskOn: true,
};
